import axios from 'axios';

export const getRoles = async ()=>{
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.REACT_APP_URL_API}/roles`)
      .then(res=>resolve(res))
      .catch(err => reject(err));
  });
}